var React = require('react');
var Modal = require('react-bootstrap').Modal;
var Button = require('react-bootstrap').Button;
var ButtonLink = require('react-router-bootstrap').ButtonLink;
var Access = require('./Access');

var Loading = require('../Loading');
var ServiceActions = require('../../actions/ServiceActions');
var ClientServiceStore = require('../../stores/ClientServiceStore');
var ClientStore = require('../../stores/ClientStore');
var ContactStore = require('../../stores/ContactStore');
var UserStore = require('../../stores/UserStore');
var Invocation = require('../../api/Invocation');

function getState(props) {
  const client = ClientStore.get()
  const partners = (client ? client.authorisedPartners : []) || []

  return {
    client,
    partner: partners.find(p => p.partner.authHash === props.params.id),
    loading: ContactStore.loading() || ClientStore.loading(),
    working: ContactStore._working,
  }
}

var AccessPartner = React.createClass({
  contextTypes: {
    router: React.PropTypes.func
  },
  componentDidMount: function() {
    ClientStore.addChangeListener(this.update);
    ContactStore.addChangeListener(this.update);
    UserStore.addChangeListener(this.update);
  },
  componentWillMount: function () {
    this.update()

    var user = UserStore.getUser();

    if (user && !ClientServiceStore.has() && !ClientServiceStore.loading()) {
      ServiceActions.getServices(user);
    }
  },
  componentWillUnmount: function () {
    ClientStore.removeChangeListener(this.update);
    ContactStore.removeChangeListener(this.update);
    UserStore.removeChangeListener(this.update);
  },
  handleDeauth: function () {
    Invocation.partner.deauthorise(
      this.state.partner.partner.id,
      this.state.client.id
    )
      .then(() => this.context.router.transitionTo('access'))
      .then(() => setTimeout(() => ServiceActions.getServices(), 200))
  },
  update: function () {
    this.setState(getState(this.props))
  },
  getInitialState: function () {
    return {
      errors: null,
      working: null,
    }
  },
  render: function () {
    return (
      <div>
        <Access />

        <Modal
          animation={false}
          onHide={() => this.context.router.transitionTo('access')}
          show
        >
          <div className="modal-header">
            <h4>Manage Partner Authorisation</h4>
          </div>
          <div className="modal-body">
            <p>
              {this.state.partner ? <b>{this.state.partner.partner.name}</b> : <Loading />} is authorised to access and manage technical information on your account.
            </p>

            <p className="text-red">
              Removing {this.state.partner ? <b>{this.state.partner.partner.name}</b> : <Loading />} from your account means that they will no longer be able to act on your behalf.
            </p>
          </div>
          <div className="modal-footer">
            <Button className="pull-left" bsStyle="danger" onClick={this.handleDeauth}>
              {this.state.working === 'DEAUTH' && (
                <span><i className="fa fa-spinner fa-spin"></i> </span>
              )}
              Remove {this.state.partner ? <b>{this.state.partner.partner.name}</b> : <Loading />}
            </Button>
            <ButtonLink to="access">Close</ButtonLink>
          </div>
        </Modal>
      </div>
    );
  }
})
module.exports = AccessPartner;



// WEBPACK FOOTER //
// ./app/components/Access/AccessPartner.js